import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePasswordDialog = ({ open, onOpenChange }) => {
  const [form, setForm] = useState(EMPTY);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 8) return toast.error("La nuova password deve avere almeno 8 caratteri");
    if (form.next !== form.confirm) return toast.error("Le due password non coincidono");
    try {
      await api.changePassword({ current_password: form.current, new_password: form.next });
      toast.success("Password aggiornata");
      setForm(EMPTY);
      onOpenChange(false);
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  const fields = [["current", "Password attuale", "current-password"], ["next", "Nuova password (min. 8 caratteri)", "new-password"], ["confirm", "Ripeti nuova password", "new-password"]];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="change-password-dialog" className="w-[calc(100%-2rem)] rounded-2xl sm:max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display">Cambia password</DialogTitle>
          <DialogDescription>Scegli una password che usi solo per questa app.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {fields.map(([k, label, ac]) => (
            <div key={k} className="space-y-1.5">
              <Label className="text-xs font-medium text-slate-600">{label}</Label>
              <Input data-testid={`change-password-${k}`} type="password" autoComplete={ac} required value={form[k]} onChange={set(k)} className="h-11 rounded-xl" />
            </div>
          ))}
          <Button type="submit" data-testid="change-password-submit" className="h-11 w-full rounded-xl">Salva password</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
